import React from 'react'
import { IconButton, Typography } from '@material-ui/core'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import RonadIcons from '../iconComponent'
import { CircularProgress } from '@material-ui/core'

type Props = {
  id: string
  getFile: () => any
  file: any
  fileName: string
  link?: string
  handleChangeFileInput: (event: any) => void
  lable: string
  trash: string
  isloading: boolean
  onClick: () => void
  onDelete: () => void
  accept?: string
  disabled?: boolean
  checkFilesRequired?: boolean
  number?: { variantCount: number | null; totalCount: number | null }
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    textInput: {
      '& input, .MuiSelect-root': {
        padding: '12px 10px 12px !important'
      },

      '& .MuiInput-underline::before': {
        borderBottom: '1px solid #d8d8d8 !important'
      }
    },
    uploadInput: {
      // cursor: 'pointer',
      alignSelf: 'center',
      position: 'absolute',
      top: '0',
      right: '0',
      width: '100%',
      height: '100%',
      opacity: '0'
    },
    labelInput: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '15px',
      border: '1.5px dashed rgba(0, 0, 0, 0.25)',
      borderRadius: '4px',
      width: '100%',
      height: '100%',
      maxWidth: '500px'
      // cursor: 'pointer'
    },
    label: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'space-between'
      // cursor: 'pointer'
    },
    overlay: {
      position: 'absolute',
      top: 0,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      height: '100%',
      backgroundColor: '#E7F7F3'
    },
    overlayIsLink: {
      position: 'absolute',
      top: 0,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      height: '100%',
      backgroundColor: '#E7F7F3'
    },
    link: {
      color: '#03614B'
    },
    linkButton: {
      border: 'none',
      background: 'none',
      textDecoration: 'underline',
      paddingTop: '5px'
      // cursor: 'pointer'
    },
    deleteTextStyle: {
      color: '#FF0000'
    },
    numberAvailable: {
      padding: '5px'
    },
    labelDelete: {
      paddingTop: '10px',
      paddingBottom: '5px'
    },
    isLoadingStyle: {
      height: ' 100%',
      width: '100%',
      position: 'absolute',
      background: '#bdbdbd87',
      left: 0,
      right: 0,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      top: 0
    },
    loadingStyle: {
      display: 'none'
    }
  })
)

const FileWithLink = (props: Props) => {
  const classes = useStyles()

  const { variantCount, totalCount } = props?.number || {}

  const downLoadFile = async () => {
    try {
      const file = await props.getFile()
      const link = document.createElement('a')
      link.href = file
      link.setAttribute('download', props.fileName)
      document.body.appendChild(link)
      link.click()
      link.parentNode.removeChild(link)
    } catch (error: any) {
      //   handleError(error)
    }
  }

  const openLink = (link: string) => {
    window.open(link, '_blank')
  }

  return (
    <div className={classes.labelInput}>
      <div
        className={
          props.isloading ? classes.isLoadingStyle : classes.loadingStyle
        }
      >
        <CircularProgress />
      </div>
      {(props.fileName || props.link) && (
        <div className={props.link ? classes.overlayIsLink : classes.overlay}>
          {props.link && (
            <span className={classes.link} onClick={() => openLink(props.link)}>
              لینک فایل
            </span>
          )}
          {props.fileName && (
            <button
              type='button'
              onClick={downLoadFile}
              className={classes.linkButton}
            >
              {props.fileName.substring(0, 12)}
            </button>
          )}
          <IconButton className={classes.labelDelete} onClick={props.onDelete}>
            <RonadIcons
              style={{ color: '#FF0000', marginLeft: '5px' }}
              name='trash'
              size={0.8}
            />
            {!props.link && (
              <Typography
                className={classes.deleteTextStyle}
                variant='subtitle1'
              >
                {props.trash}
              </Typography>
            )}
          </IconButton>
          {!props.link && variantCount && (
            <>
              <Typography
                className={classes.numberAvailable}
                variant='subtitle1'
              >
                تنوع کالایی : {variantCount}
              </Typography>
              <Typography
                className={classes.numberAvailable}
                variant='subtitle1'
              >
                مجموع کالا ها : {totalCount}
              </Typography>
            </>
          )}
        </div>
      )}
      <label
        htmlFor={props.id}
        className={classes.label}
        style={{ cursor: props.disabled ? 'default' : 'pointer' }}
      >
        <RonadIcons
          name='attachment'
          size={1.2}
          className='text-disabled mb-2'
        />
        <Typography
          style={{
            color: props.disabled ? '#bdbdbd' : '#000'
          }}
        >
          {props.lable}
        </Typography>
        <input
          type='file'
          key={Date.now()}
          name={props.fileName}
          id={props.id}
          onChange={props.handleChangeFileInput}
          className={classes.uploadInput}
          accept={props.accept ? props.accept : 'all'}
          disabled={props.disabled}
          hidden
        />
      </label>
      {!props.checkFilesRequired && (
        <>
          یا
          <Typography
            style={{
              color: props.disabled ? '#bdbdbd' : '#0375E8',
              borderBottom: props.disabled
                ? 'solid 1px #bdbdbd'
                : 'solid 1px #0375E8',
              cursor: props.disabled ? 'default' : 'pointer'
            }}
            onClick={props.disabled ? undefined : props.onClick}
          >
            افزودن لینک
          </Typography>
        </>
      )}
    </div>
  )
}

export default FileWithLink
